
import { mapState } from 'vuex'

import PaymentFrame from '@pleinair/bigcolony-vue/components/cart/checkout/elements/OloCcsf.vue'

export default {
  name: 'WebCheckoutPage',
  head() {
    return this.$utils.head({}, [], [
      { src: process.env.CHECKOUT_URL }
    ])
  },
  computed: {
    ...mapState([ 'location' ]),
    ...mapState({
      handoffMode: state => state.order.handoffMode,
    }),
    isMobile() {
      return this.$mq == 'sm' || this.$mq == 'md' ? true : false
    },
    config() {
      return {
        ccFrame: PaymentFrame,
        ccID: process.env.CHECKOUT_ID,
        ccStyles: this.ccStyles,
        // Note: guestCheckout name is misleading; this config applies to both guest and signed-in users
        guestCheckout: {
          provider: 'spendgo',
        },
        disablePayInStore: false,
        headerInfo: this.headerInfo,
        handoffInfo: {
          title: 'Order Handoff',
        },
        timeInfo: {
          title: 'Order Time',
        },
        locationCardInfo: {
          separator: '•',
          showServicesOnCard: false,
          showServicesOnOperation: false,
          locationPageAction: '',
          locationPageIcon: '',
        },
        offers: {
          navigationArrows: {
            leftIconName: 'arrow-left-icon',
            leftIconClass: '',
            rightIconName: 'arrow-right-icon',
            rightIconClass: '',
          },
        },
        upsells: {
          navigationArrows: {
            leftIconName: 'arrow-left-icon',
            leftIconClass: '',
            rightIconName: 'arrow-right-icon',
            rightIconClass: '',
          },
        },
      }
    },
    ccStyles() {
      return {
        display: 'flex',
        padding: '0px 20px',
        height: '41px',
        color: '#606B75',
        'border-color': '#DAE0E7',
        'border-width': '1px',
        'border-top-left-radius': '8px',
        'border-top-right-radius': '8px',
        'border-bottom-left-radius': '8px',
        'border-bottom-right-radius': '8px',
        'border-top-style': 'solid',
        'border-left-style': 'solid',
        'border-right-style': 'solid',
        'border-bottom-style': 'solid',
        'align-items': 'flex-start',
        'font-family': 'Inter',
        'font-size': '16px',
        'font-style': 'normal',
        'font-weight': '500',
        'line-height': '130%',
        'background-color': '#FFFFFF',
        'width': '90%',
        'width': '-webkit-fill-available',
        'min-width': 'unset',
      }
    },
    checkoutCustomHeaderContent() {
      const leftAction = {
        show: true,
        iconClasses: '',
      }
      if (this.isMobile) {
        leftAction.iconName = 'arrow-left-icon'
        leftAction.label = 'Back to Locations'
        leftAction.callback = () => this.$nuxt.$router.push('/locations')
      } else {
        leftAction.iconName = 'location-icon'
      }
      return {
        // title: 'Ordering From' : 'Delivery to'
        title: this.handoffMode === 'delivery' ? 'Delivery to' : 'Ordering From',
        leftAction,
        rightAction: {
          show: !this.isMobile,
          text: 'Change Location',
          iconName: 'location-icon',
          iconClasses: '',
          label: 'Change Location',
          callback: () => this.$nuxt.$router.push('/locations'),
        },        
        locationIcon: {
          show: true,
          iconName: 'location-filled-icon',
          iconClasses: 'large primary'
        },
      }
    },
    headerInfo() {
      const title = this.location && !this.isMobile
        ? `Your order from ${this.location.name}`
        : 'Your order from'

      return {
        title,
        leftAction: {
          show: true,
          iconName: 'shopping-bag-icon',
          iconClasses: 'icon large black'
        },
        rightAction: {
          show: true,
          iconName: 'cross-icon',
          iconClasses: 'icon white',
          callback: () => this.$nuxt.$router.push('/locations'),
        },
      }
    },
  },
  async asyncData({ $utils }) {
    const checkout = await $utils.content('order/checkout')
    if (!checkout) {
      return {
        story: null,
        checkoutSections: undefined,
      }
    }

    const sections = checkout.content.sections || []
    const sectionFound = sections.find(section => section.component === 'checkout-sections')
    const checkoutSections = sectionFound ? sectionFound.sections : undefined

    checkoutSections.map(el => {
      const desktopMatches = el.desktop_row.match(/(\d+)/);
      el.section_number = desktopMatches[0];
      const mobileMatches = el.mobile_row.match(/(\d+)/);
      el.section_number_mobile = mobileMatches[0];
    })

    return {
      story: checkout,
      checkoutSections
    }
  },
}
